import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse, VoucherCode } from '../types';

const VOUCHER_CODE_URL = '/v2/voucher-codes';

class VoucherCodeService {
  static get(id: number, config?: AxiosRequestConfig): Promise<DataResponse<VoucherCode>> {
    return axios.get(`${VOUCHER_CODE_URL}/${id}`, config);
  }

  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<VoucherCode>> {
    return axios.get(`${VOUCHER_CODE_URL}`, config);
  }

  static create(data: VoucherCode, config?: AxiosRequestConfig): Promise<DataResponse<VoucherCode>> {
    return axios.post(VOUCHER_CODE_URL, data, config);
  }

  static update(data: VoucherCode, config?: AxiosRequestConfig): Promise<DataResponse<VoucherCode>> {
    return axios.post(`${VOUCHER_CODE_URL}/${data.id}`, data, config);
  }

  static patch(data: Partial<VoucherCode>, config?: AxiosRequestConfig): Promise<DataResponse<VoucherCode>> {
    return axios.patch(`${VOUCHER_CODE_URL}/${data.id}`, data, config);
  }
}

export { VoucherCodeService };
